import PropTypes from 'prop-types';
import React from 'react';
import { SelectSearch } from 'mol-ui';
import { useSelector } from 'hooks';
import { useTranslation } from 'react-i18next';

const QuizPicker = ({
    allowNone = false,
    disabled = false,
    hasError,
    height = '40px',
    margin = '0px 0px 10px 0px',
    objectChange = false,
    onChange = () => null,
    placeholder,
    type,
    value,
    width = '100%'
}) => {

    const { t } = useTranslation();
    const {
        configurations: {
            quizzes
        }
    } = useSelector('config');

    const handleChange = id => {
        if (!objectChange) {
            onChange(id);
        } else {
            onChange(quizzes.find(({ value: surveyKey }) => surveyKey === id));
        }
    };

    const quizOptions = [
        ...(allowNone ? [{ label: t('Cualquiera'), value: null }] : []),
        ...quizzes.filter(({ type: quizType }) => !type || (quizType === type))
    ];

    const selectProps = {
        disabled,
        hasError,
        height,
        margin,
        value,
        width
    };

    return (
        <SelectSearch
            { ...selectProps }
            fontSize="11px"
            options={ quizOptions }
            placeholder={ placeholder ?? t('Seleccione una encuesta') }
            onChange={ handleChange }
        />
    );
};

QuizPicker.propTypes = {
    allowNone: PropTypes.bool,
    disabled: PropTypes.bool,
    hasError: PropTypes.bool,
    height: PropTypes.string,
    margin: PropTypes.string,
    objectChange: PropTypes.bool,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.oneOf(['quiz', 'survey']),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.string
};

export default QuizPicker;
